import React, { useEffect } from 'react';
import Router from './Router';
import './App.scss';
import useAxios from '../sharedComponents/useAxios/useAxios';
import { Container } from 'reactstrap';
import Spinner from '../sharedComponents/Spinner/Spinner';
import Modals from '../sharedComponents/Modals/Modals';
import { MantineProvider } from '@mantine/core';
import { Buffer } from 'buffer';
import LocalStorage from '../sharedComponents/LocalStorage/LocalStorage';
import initPendo from '../sharedComponents/initPendo/initPendo';

function App() {
  window.Buffer = Buffer;
  const ready = useAxios();

  useEffect(() => {
    const userData = LocalStorage.userData.get();
    const manufacturer = LocalStorage.manufacturerData.get();

    if (userData && manufacturer && userData.user) {
      initPendo(userData.user, manufacturer);
    }
  }, []);

  if (!ready) {
    return (
      <Container />
    );
  }
  return (
    <MantineProvider>
      <Router />
      <Modals />
      <Spinner />
    </MantineProvider>
  );
};

export default App;
